import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

type MenuItem = {
  value: string | null;
  svgIcon?: string;
  title: string;
  isOpen: boolean;
  children?: MenuItem[];
  disabled?: boolean;
};

@Component({
  selector: 't-llevo-details-side-menu',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './details-side-menu.component.html',
  styleUrl: './details-side-menu.component.css',
})
export class DetailsSideMenuComponent {
  @Output() activeMenuChange = new EventEmitter<string>()
  
  @Input({required: true}) menu!: MenuItem[]
  @Input({required: true}) activeMenuItem!: string

  setActiveMenu(value: string) {
    this.activeMenuChange.emit(value)
  }
}
